import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'op-news',
  templateUrl: './news.component.html'
})
export class NewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
